import { labelForScoreBand, resolveScoreTone } from './helpers'
import { Badge, ScoreNumber, ScoreLabel } from './styled'
import { MatchScoreBadgeProps } from './types'

/**
 * Compact pill that surfaces a 0–100 match score with a tone band. Used
 * inline on listing cards (small, no label) and prominently on the
 * detail page (large, with the band label).
 *
 * @param {MatchScoreBadgeProps} props
 * @returns {JSX.Element}
 */
const MatchScoreBadge = ({
  score,
  size = 'md',
  withLabel = false,
}: MatchScoreBadgeProps): JSX.Element => {
  const tone = resolveScoreTone(score)
  const bandLabel = labelForScoreBand(score)

  return (
    <Badge
      size={size}
      tone={tone}
      title={bandLabel}
      aria-label={`${score} percent match — ${bandLabel}`}
    >
      <ScoreNumber>{score}%</ScoreNumber>
      {withLabel === true ? <ScoreLabel>· {bandLabel}</ScoreLabel> : null}
    </Badge>
  )
}

export default MatchScoreBadge
